import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';

const AlertTypesApiList = () => {
    return (
        <Box sx={{ marginBottom: 2 }}>
            <Typography
                variant="body2"
                fontWeight={600}
                fontSize={15}
                sx={{ 
                    textDecoration: 'underline', 
                    cursor: 'pointer',
                    color: '#374151',
                    '&:hover': {
                        color: '#1f2937',
                        textDecoration: 'underline'
                    }
                }}
                onClick={() => {
                    const alertTypesElement = document.getElementById("alert-types");
                    if (alertTypesElement) {
                        alertTypesElement.scrollIntoView({ behavior: "smooth", block: "start" });
                    }
                }}
            >
                Alert Types
            </Typography>
        </Box>
    );
};

export default AlertTypesApiList;
